import React, { useEffect, useState } from 'react';
import { IconMoon, IconSun } from '../Icons';
import { getAllMarketHourStatuses, getSolarTimelinePercent } from './clientReportingMarketHoursUtils';

function MarketHoursMap({ statuses, timelinePercent }) {
  return (
    <div className="vd-ml-hours-map" aria-hidden="true">
      <img
        src={`${process.env.PUBLIC_URL}/world-map.svg`}
        alt=""
        className="vd-ml-hours-map-image"
        draggable={false}
      />

      <div className="vd-ml-hours-map-overlay">
        <div
          className="vd-ml-hours-now-line"
          style={{ left: `${timelinePercent}%` }}
        >
          <span className="vd-ml-hours-now-dot" />
        </div>

        {statuses.map((market) => (
          <div
            key={`${market.id}-label`}
            className={`vd-ml-hours-map-label${market.isOpen ? ' open' : ''}`}
            style={{ left: `${market.mapLeft}%`, top: `${market.mapTop}%` }}
          >
            <span className="vd-ml-hours-map-icon">
              {market.isOpen ? <IconSun size={11} /> : <IconMoon size={11} />}
            </span>
            <span className="vd-ml-hours-map-name">{market.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ClientReportingMarketHours() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);

  const statuses = getAllMarketHourStatuses(now);
  const timelinePercent = getSolarTimelinePercent(now);

  return (
    <section className="vd-panel vd-ml-widget vd-ml-market-hours">
      <div className="vd-ml-widget-header">
        <h3>Market Hours</h3>
      </div>

      <MarketHoursMap statuses={statuses} timelinePercent={timelinePercent} />

      <ul className="vd-ml-hours-list">
        {statuses.map((market) => (
          <li key={market.id} className={`vd-ml-hours-row${market.isOpen ? ' open' : ''}`}>
            <span className="vd-ml-hours-icon" aria-hidden="true">
              {market.isOpen ? <IconSun size={14} /> : <IconMoon size={14} />}
            </span>
            <span className="vd-ml-hours-name">{market.name}</span>
            <span className="vd-ml-hours-countdown">{market.statusText}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
